import {
  FETCH_PATIENT_FAIL,
  FETCH_PATIENT_REPORT_FAIL,
  FETCH_PATIENT_REPORT_REQUEST,
  FETCH_PATIENT_REPORT_SUCCESS,
  FETCH_PATIENT_REQUEST,
  FETCH_PATIENT_SUCCESS,
  SHOW_PATIENT_FAIL,
  SHOW_PATIENT_REQUEST,
  SHOW_PATIENT_SUCCESS,
} from "../../ActionType/PatientType/PatientType";

export const getPatientReducer = (
  state = { loading: true, patients: [], total: 0, error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_PATIENT_REQUEST:
      return {
        loading: true,
        patients: [],
        total: 0,
      };
    case FETCH_PATIENT_SUCCESS:
      return {
        loading: false,
        patients: action.payload.data,
        total: action.payload.total,
        error: "",
      };
    case FETCH_PATIENT_FAIL:
      return {
        loading: false,
        patients: [],
        total: 0,
        error: "",
      };
    default:
      return state;
  }
};

export const getPatientReportReducer = (
  state = { loading: true, patients: [], total: 0, error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_PATIENT_REPORT_REQUEST:
      return {
        loading: true,
        patients: [],
        total: 0,
      };
    case FETCH_PATIENT_REPORT_SUCCESS:
      return {
        loading: false,
        patients: action.payload.data,
        total: action.payload.total,
        error: "",
      };
    case FETCH_PATIENT_REPORT_FAIL:
      return {
        loading: false,
        patients: [],
        total: 0,
        error: "",
      };
    default:
      return state;
  }
};

export const showPatientReducer = (
  state = { loading: true, patients: [], error: "" },
  action
) => {
  switch (action.type) {
    case SHOW_PATIENT_REQUEST:
      return {
        loading: true,
        patients: [],
      };
    case SHOW_PATIENT_SUCCESS:
      return {
        loading: false,
        patients: action.payload.data,

        error: "",
      };
    case SHOW_PATIENT_FAIL:
      return {
        loading: false,
        patients: [],

        error: "",
      };
    default:
      return state;
  }
};
